import Vue from "vue";

import comboComponent from "@/components/child/form/combo.vue";
import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component } from "@/decorators";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import TipoEntrega from "@/models/enum/tipoEntrega";
import AzulCargoService from "@/services/azulCargoService";

import "@/components/parent/crud/crud.scss";

const azulCargoService = new AzulCargoService();

@Component({
    components: {
        comboComponent,
        shortcutComponent,
    },
})
export default class AzulCargoComponent extends Vue {
    private shortcutComponent: ShortcutComponent = null;

    tipoEntregaOptions = EnumExtensions.getNamesAndValuesOrderedByValues(TipoEntrega);

    private tipoEntrega = TipoEntrega.Domiciliar;
    private natureza = "";
    private observacao = "";
    private volume = 1;
    private vendaId = null;

    public async show(vendaId: number) {
        this.vendaId = vendaId;
        this.tipoEntrega = TipoEntrega.Domiciliar;
        this.natureza = "";
        this.observacao = "";
        this.volume = 1;

        this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;
        this.shortcutComponent.title = this.$t("__.ts.minutaAzulCargo").toString();

        this.shortcutComponent.show();
    }

    public async onSave() {
        try {
            if (await this.$validator.validateAll()) {
                const sucesso = await azulCargoService
                    .gerarMinuta({
                        vendaId: this.vendaId,
                        tipoEntrega: this.tipoEntrega,
                        natureza: this.natureza,
                        observacao: this.observacao,
                        volume: this.volume,
                    })
                    .withLoading()
                    .resolveWithoutJSON();

                if (sucesso) {
                    await this.$showSuccess(
                        this.$t("__.ts.sucesso"),
                        this.$t("__.Crud.expedicao.azulCargo_vue_html.sucesso"),
                    );

                    this.$emit("onGenerated");
                }

                this.shortcutComponent.hide();
            } else {
                this.$focusErrorField();
            }
        } catch {}
    }
}
